import React, { useEffect, useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import { SearchOutlined } from '@ant-design/icons'
import { debounce } from 'lodash'
import { useGetCommonEventListing } from 'api/Events'
import Spinner from 'components/Spinner'
import { Pagination } from 'antd'
import { CommonEventResp } from 'types/event/events'
import noImg from 'assets/Images/noImage.jpg'
import { webContentStore } from 'state/setting/webContent'
import moment from 'moment'

interface EventModalProps {
  modalOpen: boolean
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  selectedEvent: any
  setSelectedEvent: React.Dispatch<React.SetStateAction<any>>
}

const EventModal: React.FC<EventModalProps> = ({
  modalOpen,
  setModalOpen,
  selectedEvent,
  setSelectedEvent,
}) => {
  const { slides, currentSlide, updateSlideContent } = webContentStore()
  const [parms, setParms] = useState({
    page: 1,
    limit: 10,
    queryString: '',
  })
  const handleClose = () => {
    setModalOpen(false)
  }

  const handleSearchChange = (e: string) => {
    setParms({ ...parms, queryString: e, page: 1 })
  }
  const PaginationChanger = (pageNumber: number, pageSize: number) => {
    setParms({ ...parms, page: pageNumber, limit: pageSize })
  }

  const debounced = debounce(handleSearchChange, 300)

  const { isLoading, isFetching, refetch, data } =
    useGetCommonEventListing(parms)

  const handleEventSelect = (event: CommonEventResp) => {
    setSelectedEvent(event)
    updateSlideContent(slides[currentSlide].id, {
      ...slides[currentSlide],
      event: {
        name: event.name,
        coverPhoto: event.coverPhotos[0]?.original || noImg,
        date: moment(event.datesOfEvent[0]).format('YYYY-MM-DD'),
        venue:
          event.venueType === 'virtual'
            ? 'Online'
            : event.venueType === 'to-be-determined'
            ? 'TBD'
            : `${event.location.apartment}, ${event.location.city} ${event.location.state}`,
      },
      commonEventId: event._id,
    })
    setModalOpen(false)
  }

  useEffect(() => {
    refetch()
  }, [parms])

  return (
    <CustomModal
      openModal={modalOpen}
      isCloseModalCustom={true}
      closeModal={setModalOpen}
      title="Select event"
      footer={false}
    >
      <>
        <div className="search-input-box">
          <input
            type="search"
            className="search-input-group"
            placeholder="Search"
            onChange={e => {
              e.preventDefault()
              debounced(e.target.value)
            }}
          />
          <SearchOutlined />
        </div>

        <div className="py-20px">
          {isLoading || isFetching ? (
            <div>
              <Spinner />
            </div>
          ) : (
            <div>
              {data.records.length > 0 ? (
                data.records.map((event: CommonEventResp) => {
                  return (
                    <div
                      className="flex align-center gap-10px mb-16px pointer"
                      key={event._id}
                      onClick={() => handleEventSelect(event)}
                    >
                      <img
                        style={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '12px',
                        }}
                        src={event.coverPhotos[0]?.original || noImg}
                        alt="event-cover"
                        width={100}
                        height={100}
                      />
                      <h3>{event.name}</h3>
                    </div>
                  )
                })
              ) : (
                <div>
                  <p>No events available</p>
                </div>
              )}
              <div className="mt-40px flex justify-center align-center align-center">
                <Pagination
                  defaultCurrent={parms?.page}
                  total={data?.count}
                  onChange={PaginationChanger}
                  showSizeChanger={false}
                />
              </div>
            </div>
          )}
        </div>
      </>
    </CustomModal>
  )
}

export default EventModal
